export class ReferenceFileInformation {
  constructor(public id: number, public name: string) {
  }
}
